import { action, makeObservable, observable } from 'mobx';
import { videoTypes } from '../enums';

class GameActiveVideoStore {
  start = false;

  kick = false;

  process = false;

  finish = false;

  loadedVideos = {
    [videoTypes.start]: false,
    [videoTypes.kick]: false,
    [videoTypes.process]: false,
    [videoTypes.finish]: false,
  };

  constructor() {
    makeObservable(this, {
      start: observable,
      process: observable,
      finish: observable,
      kick: observable,
      loadedVideos: observable.deep,
      setLoadedVideos: action.bound,
      setGameKick: action.bound,
      setGameStart: action.bound,
      setGameProcess: action.bound,
      setGameFinish: action.bound,
      resetActiveGameVideo: action.bound,
      resetLoadedVideosState: action.bound,
    });
  }

  resetActiveGameVideo() {
    this.start = false;
    this.process = false;
    this.finish = false;
    this.kick = false;
  }

  setGameStart(isStart) {
    this.process = false;
    this.finish = false;
    this.kick = false;
    this.start = isStart;
  }

  setGameKick(isKick) {
    this.start = false;
    this.kick = isKick;
  }

  setGameProcess(isProcess) {
    this.start = false;
    this.kick = false;
    this.process = isProcess;
  }

  setGameFinish(isFinish) {
    this.process = false;
    this.finish = isFinish;
  }

  setLoadedVideos(videoName, isVideoLoaded) {
    this.loadedVideos = {
      ...this.loadedVideos,
      [videoName]: isVideoLoaded,
    };
  }

  resetLoadedVideosState() {
    this.loadedVideos = {
      [videoTypes.start]: false,
      [videoTypes.kick]: false,
      [videoTypes.process]: false,
      [videoTypes.finish]: false,
    };
  }
}

export const gameActiveVideoStore = new GameActiveVideoStore();
